import Image from "@/components/ui/app-image";
import { ButtonLink } from "@/components/ui/buttonlink";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { useConfigStore } from "@/store/use-config-store";
import { createFileRoute } from "@tanstack/react-router";
import { useShallow } from "zustand/react/shallow";
import { useLng } from "@/hooks/use-lng";

export const Route = createFileRoute("/_app/account/completedregistration")({
  head: () => appTitleHead("complete-registration-header"),
  component: CompletedRegistrationPage
});

function CompletedRegistrationPage() {
  const [settings] = useConfigStore(useShallow((state) => [state.settings]));
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");

  const gmailIcon = settings?.basePath
    ? `${settings?.basePath}/icons/gmail.svg`
    : "/icons/gmail.svg";
  const outlookIcon = settings?.basePath
    ? `${settings?.basePath}/icons/outlook.svg`
    : "/icons/outlook.svg";
  const yahooIcon = settings?.basePath
    ? `${settings?.basePath}/icons/yahoo.svg`
    : "/icons/yahoo.svg";
  const appleIcon = settings?.basePath
    ? `${settings?.basePath}/icons/apple.svg`
    : "/icons/apple.svg";

  return (
    <div>
      <h1 className="hidden text-left md:block">{t("complete-registration-header")}</h1>
      <p className="mb-0">{t("complete-registration-first-description")}</p>
      <p className="m-0">{t("complete-registration-second-description")}</p>
      <div className="mt-8">
        <p className="font-semibold">{t("complete-registration-shortcuts")}</p>
        <div className="mt-2 flex flex-col gap-3 md:flex-row">
          <ButtonLink variant="secondary" href="https://mail.google.com">
            <Image
              src={gmailIcon}
              className="mr-2"
              width={20}
              height={20}
              alt="gmail logo"
              aria-hidden={true}
            />
            Gmail
          </ButtonLink>
          <ButtonLink variant="secondary" href="https://login.live.com/">
            <Image
              src={outlookIcon}
              className="mr-2"
              width={20}
              height={20}
              alt="outlook logo"
              aria-hidden={true}
            />
            Outlook
          </ButtonLink>
          <ButtonLink variant="secondary" href="https://mail.yahoo.com/">
            <Image
              src={yahooIcon}
              className="mr-2"
              width={65}
              height={20}
              alt="yahoo logo"
              aria-hidden={true}
            />
            Yahoo Mail
          </ButtonLink>
          <ButtonLink variant="secondary" href="https://www.icloud.com/">
            <Image
              src={appleIcon}
              className="mr-2"
              width={16}
              height={20}
              alt="apple logo"
              aria-hidden={true}
            />
            Apple
          </ButtonLink>
        </div>
      </div>
    </div>
  );
}
